import React, { useState } from "react";
import "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { AttachmentSharp, KeyboardBackspace } from "@mui/icons-material";

const Media = ({
  selectedApplicationName,
  setActiveView,
  togglePopup,
  mediaFiles,
  conversations,
}) => {
  const [selectedTab, setSelectedTab] = useState("Attachments");
  const getRandomBgColor = () => {
    const colors = [
      "bg-red-300",
      "bg-blue-300",
      "bg-green-300",
      "bg-yellow-300",
      "bg-purple-300",
      "bg-pink-300",
      "bg-indigo-300",
      "bg-teal-300",
      "bg-orange-300",
    ];
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  };

  return (
    <div className="bg-white flex flex-col h-full">
      {/* Header */}
      <div className="bg-black text-white flex items-center justify-between px-4 py-3">
        <div
          className="flex items-center space-x-3 cursor-pointer"
          onClick={() => setActiveView("chat")}
        >
          <KeyboardBackspace className="text-white cursor-pointer" />
          <h1 className="text-lg font-semibold">{selectedApplicationName}</h1>
        </div>
        <div className="flex items-center space-x-3">
          <CloseIcon
            className="text-white cursor-pointer"
            onClick={togglePopup}
          />
        </div>
      </div>

      <div className="flex flex-col items-center p-4 space-y-2 cursor-pointer w-full justify-center bg-[#FFF7F4]">
        <img
          src={"/img/images.png"}
          alt="Logo"
          className="w-20 h-20 rounded-full bg-white p-1"
        />
        <h1 className="text-xl font-semibold">{selectedApplicationName}</h1>
      </div>
      <div className="text-lg font-medium px-4 py-2">Media</div>
      <div className="border-b flex">
        <button
          className={`px-4 py-2  ${selectedTab === "Attachments"
            ? "bg-white border-b-2 border-[#f26522] text-[#f26522]"
            : "text-gray-600"
            }`}
          onClick={() => setSelectedTab("Attachments")}
        >
          Attachments
        </button>
        <button
          className={`px-4 py-2  ${selectedTab === "Members"
            ? "bg-white border-b-2 border-[#f26522] text-[#f26522]"
            : "text-gray-600"
            }`}
          onClick={() => setSelectedTab("Members")}
        >
          Members
        </button>
      </div>
      {/* Media View */}
      {selectedTab === "Attachments" && (
        <div className="flex-1 overflow-y-auto p-4">
          {mediaFiles.length > 0 ? (
            <div className="grid grid-cols-3 gap-4">
              {mediaFiles.map((url, index) => {
                const filename = url.split("/").pop().split("?")[0];
                const fileExtension = filename.split(".").pop().toLowerCase();
                const isImage = ["jpeg", "jpg", "gif", "png", "bmp"].includes(
                  fileExtension
                );

                return (
                  <div
                    key={index}
                    className="relative rounded-md shadow-md overflow-hidden"
                  >
                    {isImage ? (
                      <img
                        src={url}
                        alt={filename}
                        className="w-full h-32 object-cover"
                      />
                    ) : (
                      <div className="w-full h-32 bg-gray-100 flex items-center justify-center">
                        <AttachmentSharp
                          className="text-gray-500"
                          size="large"
                        />
                        <p className="text-sm text-gray-600 mt-2 text-center">
                          {filename}
                        </p>
                      </div>
                    )}
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 text-white opacity-0 hover:opacity-100 transition-opacity"
                    >
                      View
                    </a>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-gray-600">No media available.</p>
          )}
        </div>
      )}

      {/* Members View */}
      {selectedTab === "Members" && (
        <div className="flex-1 overflow-y-auto p-4">
          {conversations?.history?.users?.length > 1 ? ( // Ensure there are more than 1 user
            conversations.history.users.slice(1).map(
              (
                user // Skip the first user
              ) => (
                <div
                  key={user.email_id}
                  className="flex items-center space-x-2 mb-3"
                >
                  <div
                    className={`flex-shrink-0 ${getRandomBgColor()} text-gray-700 w-8 h-8 min-w-[2rem] min-h-[2rem] flex items-center justify-center rounded-full  font-medium`}
                  >
                    {user.description
                      ? user.description.charAt(0)
                      : user.email_id.charAt(0)}
                  </div>
                  <div>
                    <p className=" font-medium text-gray-800">
                      {user.description || "Unknown User"}
                    </p>
                    <p className="text-sm text-gray-500">{user.email_id}</p>
                  </div>
                </div>
              )
            )
          ) : (
            <p className="text-gray-600">No members available.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Media;
